'use strict';

angular.module('shiftTraderApp')
    .directive('saHomeDaySlide', ['$state', '$compile', 'Session', 'HomeCoordinator', 'TimeService', function($state, $compile, Session, HomeCoordinator, TimeService) {
      return {
        template: '<div class="slide_swipe"></div>',
        require: '^saHomeSlider',
        scope: {
          date: '@'
        },
        replace: true,
        link: function(scope, element, attr, ctrl) {
          console.log('LINK: saSlideSwipe @ ' + attr.identifier);
          scope.name = attr.identifier;
          scope.currentDate = TimeService.getBeginningOfDayFromDate(moment(scope.date));
          scope.hasRendered = false;

          scope.me = undefined;

          Session.getMe()
            .then(function(me) {
              scope.me = me;
            }, function(response) {
              console.log('Failed to fetch \'me\'.', response);
            });

          scope.title = scope.currentDate.format('dddd, MMM DD');

          ctrl.registerSlide({
            element: element,
            scope: scope,
            name: scope.name
          });

          scope.goToDaysOff = function() {
            if (scope.daysOff.length > 1) {
              $state.go('profile.daysOff.overview', { userId: scope.me.id });
            } else {
              $state.go('profile.daysOff.show', { userId: scope.me.id, dayOffId: scope.daysOff[0].id });
            }
          };

          scope.goToPickup = function(index) {
            $state.go('workPeriods.show', { workPeriodId: scope.pickups[index].id });
          };

          scope.goToAvailability = function() {
            $state.go('profile.availability.main', { userId: scope.me.id });
          };

          scope.getWorkPeriodUrl = function(wp) {
            return '#/workPeriods/' + wp.id;
          };

          function loadData() {
            scope.layout = {
              name: 'layout-date-only',
              data: {
                date: scope.currentDate
              }
            };

            HomeCoordinator.getDayOffRules(scope.currentDate)
              .then(function(daysOff) {
                scope.daysOff = daysOff;
              }, function(response) {
                console.log('Failed to fetch days off on', scope.currentDate.format(), response);
              });

            HomeCoordinator.getDayShifts(scope.currentDate)
              .then(function(shifts) {
                scope.shifts = shifts;
              }, function(response) {
                console.log('Failed to fetch shifts on', scope.currentDate.format(), response);
              });

            HomeCoordinator.getDayPickups(scope.currentDate)
              .then(function(pickups) {
                scope.pickups = pickups;
              }, function(response) {
                console.log('Failed to fetch pickups on', scope.currentDate.format(), response);
              });

            HomeCoordinator.getDayAvailability(scope.currentDate)
              .then(function(availability) {
                scope.availability = availability;
                if (scope.availability && !scope.availability.availSet) {
                  scope.availability = null;
                }

                if (scope.availability && scope.availability.availSet) {
                  scope.lastUpdatedAvailability = moment(scope.availability.availSet.updated_at).tz(Session.getTimezone()).format('MMM DD');
                }
              }, function(response) {
                console.log('Failed to fetch availability rules on', scope.currentDate.format(), response);
              });
          }

          scope.$on('saHomeSlider:renderSlide' + attr.identifier, function() {
            if (!scope.hasRendered) {
              $(element).html($compile('<div ng-include="\'views/directives/saHomeDaySlide.html\'"></div>')(scope));
              loadData();
              scope.hasRendered = true;
            }
          });
        }
      };
    }]);
